import { I18n } from "i18n-js";
import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import it from "./it.json";
import de from "./de.json";
import pt from "./pt.json";
import zhCN from "./zh-CN.json";
import zhTW from "./zh-TW.json";

const i18n = new I18n({ ...en, ...es, ...fr, ...it, ...de, ...pt, ...zhCN, ...zhTW });
i18n.defaultLocale = "en";
// Without this a key present only in en.json renders as
// `[missing "es.javascript...." translation]` for every other locale. English
// is the right stand-in until a translator fills the gap — a bracketed marker
// never is. Only affects keys that are already absent.
i18n.enableFallback = true;
i18n.locale = document.documentElement.lang || "en";

window.I18n = i18n;

export default i18n;
